import { PropsWithChildren } from 'react'
import LabelLine from '../icons/LabelLine'

type PropTypes = {
  name?: string
  withLine?: boolean
} & PropsWithChildren

export default function TextInput ({
  name,
  children,
  withLine = true,
}: PropTypes) {
  return (
    <label
      className="mb-2.5 text-gray-900 text-[13px] leading-[15.6px] flex gap-[11px] items-center font-mono uppercase"
      htmlFor={name}
    >
      {children}
      {
        withLine
          && (
            <LabelLine className="w-[31px] h-[11px]" />
          )
      }
    </label>
  )
}
